module.exports = __webpack_public_path__ + "static/media/Wajdi Mereb (1).48ada4a7.jpeg";